import { isBoolean as t } from "../../utils/types.js";
const l = {
  visible: {
    type: Boolean,
    default: !1
  },
  title: {
    type: String,
    default: ""
  },
  width: {
    type: [String, Number]
  },
  popupClass: {
    type: String,
    default: ""
  },
  closeOnClickOverlay: {
    type: Boolean,
    default: !0
  },
  zIndex: {
    type: Number
  },
  modal: {
    type: Boolean,
    default: !0
  },
  draggable: {
    type: Boolean,
    default: !1
  }
}, p = {
  open: () => !0,
  opened: () => !0,
  close: () => !0,
  closed: () => !0,
  "update:visible": (e) => t(e)
};
export {
  p as popupEmits,
  l as popupProps
};
